import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/auth/users";

export const registerUser = async (payload) => {
    console.log(payload);
  try {
    const response = await axios.post(`${API_BASE}/register`, payload);
    return { success: true, data: response.data };
  } catch (error) {
    if (error.response) {
      // Backend handled error
      return {
        success: false,
        error: error.response.data,
      };
    }

    // Network or unknown error
    return {
      success: false,
      error: { message: "Something went wrong. Please try again." },
    };
  }
};

export async function resendPasswordLink({ email, userType }) {
    console.log("PUTTING "+email+" "+userType)
    const token = JSON.parse(localStorage.getItem("user"))?.token;

    const res = await fetch(
        API_BASE+"/password-link/resend",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email,
                userType,
            }),
        }
    );
    return res.json();
}

export const updateUser = async (payload) => {
  try {
    const response = await fetch(process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/users/update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-source-system": "web",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      return {
        success: false,
        message: result.message || "Failed to update user",
        error: result.errors || null,
      };
    }

    return {
      success: true,
      data: result.data,
      message: result.message || "User Updated Successfully",
    };
  } catch (error) {
    console.error("updateUser error:", error);
    return {
      success: false,
      message: "Something went wrong while updating user",
      error,
    };
  }
};

export const updateUserStatus = async (payload) => {
    try {
        const response = await fetch(
            process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/users/update/status",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-source-system": "web",
                },
                body: JSON.stringify(payload),
            }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
            return {
                success: false,
                message: result.message || "Failed to update user status",
                error: result.errors || null,
            };
        }

        return {
            success: true,
            data: result.data,
            message: result.message || "User status updated successfully",
        };
    } catch (error) {
        console.error("updateUserStatus error:", error);
        return {
            success: false,
            message: "Something went wrong while updating user status",
            error,
        };
    }
};

